/**
 *  /dashboard/sell/:addressUUID?/history
 *  /----0----/--1-/------2-----/---3---
 */
export const parseAddressRoute = (pathname: string) => {
  const splitPath = pathname.split('/').slice(1);
  // Returns undefined if not a valid UUID - for buy-only routes
  // case insensitive regex for UUID
  const UUID_REGEX =
    /^[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}$/i;
  const addressUUID = UUID_REGEX.test(splitPath[2]) ? splitPath[2] : undefined;
  const basePath = `/dashboard/${splitPath[1]}`;
  // Accomodates for the optional addressUUID
  const subPathSliceIndex = addressUUID ? 3 : 2;
  const subPath =
    splitPath.length > subPathSliceIndex ? `/${splitPath.slice(subPathSliceIndex).join('/')}` : '';
  return { addressUUID, basePath, subPath };
};
